import React from "react";
import { Link } from "@jsluna/link";

import NotificationPage from "../../NotificationPage";
import missionConfig from "missionConfig";
import { withMetaData } from "selectors";
import { defaultHomePage } from "constants/missions";

const AccountBlockedNotification = ({ missionName, number }) => {
  const metadata = withMetaData();
  return (
    <NotificationPage
      title={`Your ${missionName} account is not available right now`}
      warningInfo={
        missionConfig.showChatLinkForDeceasedUsers
          ? `To access your account please contact us on the`
          : `To access your account please call customer service on ${number}`
      }
      warningInfoLink={
        missionConfig.showChatLinkForDeceasedUsers &&
        metadata &&
        metadata.live_chat_url
      }
      warningInfoLinkLabel={
        missionConfig.showChatLinkForDeceasedUsers &&
        metadata &&
        "Nectar live chat"
      }
    >
      <Link
        cta
        bare
        color="alpha"
        href={metadata ? metadata.mission_homepage : defaultHomePage}
      >
        Back to homepage
      </Link>
    </NotificationPage>
  );
};

export default AccountBlockedNotification;
